module.exports = __webpack_public_path__ + "img/KSC03619.391ddc18.jpg";